var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefiSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    viewBox: "0 0 248 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H224C237.255 0 248 10.7452 248 24V100C248 113.255 237.255 124 224 124H24C10.7452 124 0 113.255 0 100V24Z",
    fill: "#50B0B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1816 53.1807L120.201 67.6255C120.47 67.7811 120.753 67.8934 121.04 67.9647V95.9797L96.966 81.7326C95.86 81.078 95.1816 79.8883 95.1816 78.6031V53.1807ZM153.364 52.7968V78.6032C153.364 79.8883 152.685 81.0781 151.579 81.7326L127.505 95.9797V67.7193C127.564 67.69 127.622 67.6588 127.679 67.6256L153.364 52.7968Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9678 46.1699C96.2734 45.7839 96.6591 45.4578 97.1088 45.2183L122.563 31.6606C123.632 31.0915 124.914 31.0915 125.982 31.6606L151.437 45.2183C151.783 45.4029 152.092 45.639 152.355 45.9143L124.447 62.0271C124.264 62.1331 124.094 62.2543 123.94 62.3883C123.786 62.2543 123.617 62.1331 123.433 62.0271L95.9678 46.1699Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefiSmall);
export default __webpack_public_path__ + "static/media/defi-small.ee599c0e.svg";
export { ForwardRef as ReactComponent };